<script lang="ts" setup>
import type {SynchroHistory} from "@/domain/type/synchro.type.ts";
import {ref} from "vue";
import type {Source} from "@/domain/type/source.type.ts";
import {useSynchroStore} from "@/stores/synchro.store.ts";
import HistoryCard from "@/components/History/HistoryCard.vue";

defineProps<{
  history: SynchroHistory[],
  source: Source
}>()
const dialog = ref(false)

function click() {
  dialog.value = true
  useSynchroStore().fetchHistory()
}
</script>

<template>
  <v-btn
    class="ma-auto sourceHistoryBtn"
    color="blue"
    prepend-icon="mdi-history"
    text="Historique"
    variant="elevated"
    @click="click()"
  />
  <v-dialog v-model="dialog" width="auto">
    <history-card :history="history" :source="source" @close="dialog = false"/>
  </v-dialog>
</template>

<style>
.historyTable .v-data-table__tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}

.historyTable .v-data-table-header__content span {
  font-weight: bolder !important;
}

</style>
